import { apiRequest } from './api';

function getAuthHeaders() {
  try {
    const token = window.localStorage.getItem('chse_auth_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

export async function getCategories() {
  return apiRequest('/api/categories', {
    method: 'GET',
    headers: getAuthHeaders(),
  });
}

export async function getCategoriesWithSubcategories() {
  return apiRequest('/api/categories/with_subcategories', {
    method: 'GET',
    headers: getAuthHeaders(),
  });
}
